import type {
  ApiCommentContextType,
  ApiCommentType,
  EstimationItemResponse,
} from '@/api/schema/data-contracts';
import type { ModalSize, ModalStatelessProps } from '@/components/ModalStateless';
import { ModalStateless } from '@/components/ModalStateless';
import { useMessages } from '@/hooks/messages';

import Comments from './Comments';
import { commentsMessageDefinitions } from './messages';

type CommentsModalProps = Omit<ModalStatelessProps, 'title' | 'open'> & {
  commentType: ApiCommentType;
  commentContext: ApiCommentContextType;
  estimationId: string;
  estimationItem?: EstimationItemResponse;
  size?: ModalSize;
};

export const CommentsModal: React.FC<CommentsModalProps> = ({
  commentType,
  commentContext,
  estimationId,
  estimationItem,
  onClose,
  size,
}) => {
  const messages = useMessages(commentsMessageDefinitions);

  return (
    <ModalStateless
      className='min-w-[600px]'
      title={messages.modalTitleWithPhaseNameFormatted({ phaseName: estimationItem?.name ?? '' })}
      open={!!estimationItem?.id}
      withoutButtons
      onClose={onClose}
      size={size}
    >
      {estimationItem && (
        <Comments
          estimationId={estimationId}
          estimationItemId={estimationItem.id}
          commentType={commentType}
          commentContext={commentContext}
        />
      )}
    </ModalStateless>
  );
};
